import { render, staticRenderFns } from "./DashboardPendenciasEmAnalise.vue?vue&type=template&id=029c16b4"
import script from "./DashboardPendenciasEmAnalise.vue?vue&type=script&lang=js"
export * from "./DashboardPendenciasEmAnalise.vue?vue&type=script&lang=js"
import style0 from "./DashboardPendenciasEmAnalise.vue?vue&type=style&index=0&id=029c16b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports